var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { createDefaultSalesOrderDetailsColumnVisibility } from "./salesOrderDetailsColumns";
import { createDefaultSalesOrderDetailsRefundColumnVisibility } from "./salesOrderDetailsRefundColumns";
import { loadSalesRepOrderDetailsColumnVisibility, loadSalesRepOrderDetailsRefundColumnVisibility, persistSalesRepOrderDetailsColumnVisibility, persistSalesRepOrderDetailsRefundColumnVisibility, resolveSalesRepOrderDetailsUserId, } from "./salesOrderDetailsColumnStorage";
import FileSaver from "file-saver";
import { useDeviceQueries, formatAmount } from "../../shared/Utilites";
import { useMediaQuery } from "@mui/material";
import { getDefaultDateRange, formatDateForAPI } from "./STReports/DateRangePicker/DateRangePickerBL";
import { formatDisplayDateValue } from "../SharedFunctions";
import { displaySnackbarErrMsg, stReportsDataService, ST_ORDER_DETAILS_DEFAULT_LIST_PAGE_SIZE } from "../../services/apiServices/salesRepDataService";
import { logClientRuntimeError } from "../../services/clientErrorLog";
import { getSTOrderDetailsOrdersForUiTab, getSTOrderDetailsTabSlicesFromPayload, getSTOrderDetailsStatusDisplayLabel, SALES_ORDER_DETAILS_CSV_EXPORT_TAB_LABEL_KEYS, SALES_ORDER_DETAILS_ORDER_EXPORT_COLUMN_KEYS, SALES_ORDER_DETAILS_REFUND_EXPORT_COLUMN_KEYS, } from "../model/STOrderDetailsModel";
import { getSTOrderDetailsRefundRowsForUiTab } from "../model/stOrderDetailsRefundGrid";
function pickRowField(row, pascal, camel) {
    var _a;
    var c = camel !== null && camel !== void 0 ? camel : pascal.charAt(0).toLowerCase() + pascal.slice(1);
    return (_a = row[pascal]) !== null && _a !== void 0 ? _a : row[c];
}
function escapeCsvCell(value) {
    var s = value == null ? "" : String(value);
    // Quote fields with comma, quote, newline, or whitespace (e.g. paid date time, "Rs. 235.35").
    if (/[",\n\r]/.test(s) || /\s/.test(s)) {
        return "\"".concat(s.replace(/"/g, '""'), "\"");
    }
    return s;
}
var ST_REPORTS_CSV_DATE_SLASH_PATTERN = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
/** Case 59 API sends `MM/dd/yyyy`; keep slashes and normalize zero-padding. */
function formatStReportsCsvExportDate(raw) {
    var s = raw == null ? "" : String(raw).trim();
    if (!s || s === "-" || s.toLowerCase() === "null") {
        return "-";
    }
    var dateToken = s.split(/\s+/)[0].split("T")[0];
    var slashMatch = dateToken.match(ST_REPORTS_CSV_DATE_SLASH_PATTERN);
    if (slashMatch) {
        var mm = slashMatch[1], dd = slashMatch[2], yyyy = slashMatch[3];
        return "".concat(mm.padStart(2, "0"), "/").concat(dd.padStart(2, "0"), "/").concat(yyyy);
    }
    return formatDisplayDateValue(raw) || "-";
}
/** Quote + tab prefix so Excel keeps `MM/dd/yyyy` as text (no locale date coercion). */
function escapeCsvDateCell(raw) {
    var formatted = formatStReportsCsvExportDate(raw);
    if (formatted === "-") {
        return escapeCsvCell("-");
    }
    var safe = formatted.replace(/"/g, '""');
    return "\"\t".concat(safe, "\"");
}
function formatCsvCurrencyHeader(label, shopCurrency) {
    var symbol = String(shopCurrency !== null && shopCurrency !== void 0 ? shopCurrency : "").trim();
    return symbol ? "".concat(label, " (").concat(symbol, ")") : label;
}
/** CSV money columns match grid — locale-aware separators via formatAmount. */
function formatCsvCurrencyAmount(currency, shopCurrency, amount) {
    var num = Number(amount !== null && amount !== void 0 ? amount : 0);
    return formatAmount(Number.isFinite(num) ? num : 0, currency, shopCurrency);
}
function hasAnyVisibleOrderExportColumn(columnVisibility, selectFeatures) {
    return SALES_ORDER_DETAILS_ORDER_EXPORT_COLUMN_KEYS.some(function (key) {
        if (key === "companyName" || key === "companyLocation") {
            return !!columnVisibility[key] && !!(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder);
        }
        return !!columnVisibility[key];
    });
}
function hasAnyVisibleRefundExportColumn(columnVisibility) {
    return SALES_ORDER_DETAILS_REFUND_EXPORT_COLUMN_KEYS.some(function (key) { return !!columnVisibility[key]; });
}
function fetchAllStReportOrderRowsForExport(activeTab, dateFrom, dateTo) {
    return __awaiter(this, void 0, void 0, function () {
        var merged, pageNumber, pageSize, maxPages, req, res, batch, hasNext, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    merged = [];
                    pageNumber = 1;
                    pageSize = ST_ORDER_DETAILS_DEFAULT_LIST_PAGE_SIZE;
                    maxPages = 100;
                    _a.label = 1;
                case 1:
                    if (!(pageNumber <= maxPages)) return [3 /*break*/, 3];
                    req = {
                        dateFrom: dateFrom,
                        dateTo: dateTo,
                        dateField: "",
                        activeTab: activeTab,
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                    };
                    return [4 /*yield*/, stReportsDataService(req)];
                case 2:
                    res = _a.sent();
                    if (!res) {
                        return [3 /*break*/, 3];
                    }
                    batch = getSTOrderDetailsOrdersForUiTab(res, activeTab);
                    if (!batch.length) {
                        return [3 /*break*/, 3];
                    }
                    merged.push.apply(merged, batch);
                    hasNext = res.hasNextPage === true;
                    if (!hasNext || batch.length < pageSize) {
                        return [3 /*break*/, 3];
                    }
                    pageNumber += 1;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, merged];
                case 4:
                    error_1 = _a.sent();
                    logClientRuntimeError("fetchAllStReportOrderRowsForExport", error_1);
                    return [2 /*return*/, []];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function fetchAllStReportRefundRowsForExport(dateFrom, dateTo) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var merged, pageNumber, pageSize, maxPages, req, res, payload, batch, slices, hasNext, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    merged = [];
                    pageNumber = 1;
                    pageSize = ST_ORDER_DETAILS_DEFAULT_LIST_PAGE_SIZE;
                    maxPages = 100;
                    _b.label = 1;
                case 1:
                    if (!(pageNumber <= maxPages)) return [3 /*break*/, 3];
                    req = {
                        dateFrom: dateFrom,
                        dateTo: dateTo,
                        dateField: "",
                        activeTab: "Refunded",
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                    };
                    return [4 /*yield*/, stReportsDataService(req)];
                case 2:
                    res = _b.sent();
                    if (!res) {
                        return [3 /*break*/, 3];
                    }
                    payload = res;
                    batch = getSTOrderDetailsRefundRowsForUiTab(payload, "Refunded");
                    if (!batch.length) {
                        return [3 /*break*/, 3];
                    }
                    merged.push.apply(merged, batch);
                    slices = getSTOrderDetailsTabSlicesFromPayload(payload);
                    hasNext = ((_a = slices === null || slices === void 0 ? void 0 : slices.refunded) === null || _a === void 0 ? void 0 : _a.hasNextPage) === true;
                    if (!hasNext || batch.length < pageSize) {
                        return [3 /*break*/, 3];
                    }
                    pageNumber += 1;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, merged];
                case 4:
                    error_2 = _b.sent();
                    logClientRuntimeError("fetchAllStReportRefundRowsForExport", error_2);
                    return [2 /*return*/, []];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function buildRefundGridCsvFromSTOrderDetailsRows(rows, columnVisibility, t, shopCurrency, currency) {
    var cols = {
        refundId: !!columnVisibility.refundId,
        createdDate: !!columnVisibility.createdDate,
        orderNo: !!columnVisibility.orderNo,
        commission: !!columnVisibility.commission,
        teamManagerCommission: !!columnVisibility.teamManagerCommission,
        refundSubTotal: !!columnVisibility.refundSubTotal,
        orderStatus: !!columnVisibility.orderStatus,
        salesMethod: !!columnVisibility.salesMethod,
    };
    var headers = [];
    if (cols.refundId)
        headers.push(t("refundOrders_column1"));
    if (cols.createdDate)
        headers.push(t("refundOrders_column2"));
    if (cols.orderNo)
        headers.push(t("refundOrders_column3"));
    if (cols.commission)
        headers.push(formatCsvCurrencyHeader(t("refundOrders_column5"), shopCurrency));
    if (cols.teamManagerCommission)
        headers.push(formatCsvCurrencyHeader(t("refundOrders_column6"), shopCurrency));
    if (cols.refundSubTotal)
        headers.push(formatCsvCurrencyHeader(t("refundOrders_column8"), shopCurrency));
    if (cols.orderStatus)
        headers.push(t("refundOrders_column9"));
    if (cols.salesMethod)
        headers.push(t("refundOrders_column10"));
    var lines = rows.map(function (row) {
        var _a, _b;
        var cells = [];
        if (cols.refundId)
            cells.push(escapeCsvCell(row.RefundId));
        if (cols.createdDate)
            cells.push(escapeCsvDateCell((_a = row.CreatedDate) !== null && _a !== void 0 ? _a : "-"));
        if (cols.orderNo)
            cells.push(escapeCsvCell((_b = row.ShopifyOrderNumber) !== null && _b !== void 0 ? _b : row.OrderNo));
        if (cols.commission)
            cells.push(escapeCsvCell(formatCsvCurrencyAmount(currency, shopCurrency, row.Commission)));
        if (cols.teamManagerCommission)
            cells.push(escapeCsvCell(formatCsvCurrencyAmount(currency, shopCurrency, row.TeamManagerCommission)));
        if (cols.refundSubTotal)
            cells.push(escapeCsvCell(formatCsvCurrencyAmount(currency, shopCurrency, row.RefundSubTotal)));
        if (cols.orderStatus)
            cells.push(escapeCsvCell(getSTOrderDetailsStatusDisplayLabel(row.OrderStatus)));
        if (cols.salesMethod)
            cells.push(escapeCsvCell(row.OrderType));
        return cells.join(",");
    });
    return __spreadArray([headers.map(escapeCsvCell).join(",")], lines, true).join("\n");
}
function buildOrderGridCsvFromSTOrderDetailsRows(rows, columnVisibility, selectFeatures, t, shopCurrency, currency) {
    var cols = {
        orderNumber: !!columnVisibility.orderNumber,
        customerName: !!columnVisibility.customerName,
        orderDate: !!columnVisibility.orderDate,
        orderPaidDate: !!columnVisibility.orderPaidDate,
        companyName: !!columnVisibility.companyName && !!(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder),
        companyLocation: !!columnVisibility.companyLocation && !!(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder),
        subtotal: !!columnVisibility.subtotal,
        commission: !!columnVisibility.commission,
        salesMethod: !!columnVisibility.salesMethod,
        fulfilmentStatus: !!columnVisibility.fulfilmentStatus,
        status: !!columnVisibility.status,
    };
    var headers = [];
    if (cols.orderNumber)
        headers.push(t("myOrders_table1Column1"));
    if (cols.customerName)
        headers.push(t("draftOrder_CustName"));
    if (cols.orderDate)
        headers.push(t("stReports_col_orderDate"));
    if (cols.orderPaidDate)
        headers.push(t("yourSales_PaidOrders_PaidDate"));
    if (cols.companyName)
        headers.push(t("draftOrder_CompanyName"));
    if (cols.companyLocation)
        headers.push(t("dashboard_B2BCompanyLocation"));
    if (cols.subtotal)
        headers.push(formatCsvCurrencyHeader(t("team_column5"), shopCurrency));
    if (cols.commission)
        headers.push(formatCsvCurrencyHeader(t("yourSales_table1Column5"), shopCurrency));
    if (cols.salesMethod)
        headers.push(t("team_column8"));
    if (cols.fulfilmentStatus)
        headers.push(t("stReports_col_fulfilmentStatus"));
    if (cols.status)
        headers.push(t("stReports_col_orderStatus"));
    var lines = rows.map(function (product) {
        var _a, _b, _c, _d, _e, _f, _g;
        var cells = [];
        var tiered = pickRowField(product, "CommissionDiscountOn", "commissionDiscountOn") === "TieredGroup";
        var commissionRaw = pickRowField(product, "Commission", "commission");
        var commissionNum = Number(commissionRaw !== null && commissionRaw !== void 0 ? commissionRaw : 0);
        var commissionStr = tiered ? "Tiered Commission" : formatCsvCurrencyAmount(currency, shopCurrency, commissionNum);
        var subNum = Number((_a = pickRowField(product, "Subtotal", "subtotal")) !== null && _a !== void 0 ? _a : 0);
        if (cols.orderNumber)
            cells.push(escapeCsvCell(pickRowField(product, "OrderNumber", "orderNumber")));
        if (cols.customerName)
            cells.push(escapeCsvCell(pickRowField(product, "CustomerName", "customerName")));
        if (cols.orderDate)
            cells.push(escapeCsvDateCell(pickRowField(product, "OrderDate", "orderDate")));
        if (cols.orderPaidDate)
            cells.push(escapeCsvDateCell(pickRowField(product, "OrderPaidDate", "orderPaidDate")));
        if (cols.companyName)
            cells.push(escapeCsvCell((_b = pickRowField(product, "CompanyName", "companyName")) !== null && _b !== void 0 ? _b : "-"));
        if (cols.companyLocation)
            cells.push(escapeCsvCell((_c = pickRowField(product, "CompanyLocation", "companyLocation")) !== null && _c !== void 0 ? _c : "-"));
        if (cols.subtotal)
            cells.push(escapeCsvCell(formatCsvCurrencyAmount(currency, shopCurrency, subNum)));
        if (cols.commission) {
            cells.push(escapeCsvCell(tiered ? commissionStr : formatCsvCurrencyAmount(currency, shopCurrency, commissionNum)));
        }
        if (cols.salesMethod)
            cells.push(escapeCsvCell((_d = pickRowField(product, "SalesMethod", "salesMethod")) !== null && _d !== void 0 ? _d : pickRowField(product, "CommissionType", "commissionType")));
        if (cols.fulfilmentStatus)
            cells.push(escapeCsvCell((_f = (_e = pickRowField(product, "FulfilmentStatus", "fulfilmentStatus")) !== null && _e !== void 0 ? _e : pickRowField(product, "FulfillmentStatus", "fulfillmentStatus")) !== null && _f !== void 0 ? _f : "-"));
        if (cols.status) {
            var statusRaw = (_g = pickRowField(product, "Status", "status")) !== null && _g !== void 0 ? _g : pickRowField(product, "OrderStatus", "orderStatus");
            cells.push(escapeCsvCell(getSTOrderDetailsStatusDisplayLabel(statusRaw)));
        }
        return cells.join(",");
    });
    return __spreadArray([headers.map(escapeCsvCell).join(",")], lines, true).join("\n");
}
export function SalesOrderDetailsBL() {
    var _this = this;
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var id = open ? "simple-popover" : undefined;
    var isDesktop = useMediaQuery("(min-width: 960px)");
    var isMobile = useDeviceQueries();
    var isB2BShop = useSelector(function (state) { var _a, _b, _c; return Boolean((_c = (_b = (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.select) === null || _c === void 0 ? void 0 : _c.CreateB2BOrder); });
    var selectFeatures = useSelector(function (state) { var _a, _b, _c; return ((_c = (_b = (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.select) !== null && _c !== void 0 ? _c : {}); });
    var _b = useState(false), isCsvExporting = _b[0], setIsCsvExporting = _b[1];
    var _c = useState(getDefaultDateRange), dateRange = _c[0], setDateRange = _c[1];
    var _d = useState(null), customColumnAnchorEl = _d[0], setCustomColumnAnchorEl = _d[1];
    var t = useTranslation().t;
    var loggedInCustomerId = useSelector(function (state) { var _a, _b; return (_b = (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.loggedInRepDetails) === null || _b === void 0 ? void 0 : _b.customerId; });
    var _e = useState(function () {
        return loadSalesRepOrderDetailsColumnVisibility(isB2BShop);
    }), columnVisibility = _e[0], setColumnVisibility = _e[1];
    var _f = useState(function () {
        return loadSalesRepOrderDetailsRefundColumnVisibility();
    }), refundColumnVisibility = _f[0], setRefundColumnVisibility = _f[1];
    var prevColumnUserIdRef = useRef(resolveSalesRepOrderDetailsUserId());
    var _g = useState({ open: false, message: "" }), exportNotice = _g[0], setExportNotice = _g[1];
    var shopCurrency = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.loggedInRepDetails) === null || _b === void 0 ? void 0 : _b.shopCurrency) !== null && _c !== void 0 ? _c : ""; });
    var currency = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.loggedInRepDetails) === null || _b === void 0 ? void 0 : _b.currency) !== null && _c !== void 0 ? _c : ""; });
    var setColumnVisibilityWithPersist = useCallback(function (updater) {
        setColumnVisibility(function (prev) {
            var next = typeof updater === "function" ? updater(prev) : updater;
            persistSalesRepOrderDetailsColumnVisibility(next);
            return next;
        });
    }, []);
    var setRefundColumnVisibilityWithPersist = useCallback(function (updater) {
        setRefundColumnVisibility(function (prev) {
            var next = typeof updater === "function" ? updater(prev) : updater;
            persistSalesRepOrderDetailsRefundColumnVisibility(next);
            return next;
        });
    }, []);
    useEffect(function () {
        var userId = resolveSalesRepOrderDetailsUserId();
        if (!userId || userId === prevColumnUserIdRef.current) {
            return;
        }
        prevColumnUserIdRef.current = userId;
        setColumnVisibility(loadSalesRepOrderDetailsColumnVisibility(isB2BShop));
        setRefundColumnVisibility(loadSalesRepOrderDetailsRefundColumnVisibility());
    }, [loggedInCustomerId, isB2BShop]);
    useEffect(function () {
        setColumnVisibility(loadSalesRepOrderDetailsColumnVisibility(isB2BShop));
    }, [isB2BShop]);
    var dismissExportNotice = function () { return setExportNotice({ open: false, message: "" }); };
    var showExportNotice = function (message) {
        setExportNotice({ open: true, message: message });
    };
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () { return setAnchorEl(null); };
    var handleCustomColumnsClick = function (event) {
        setCustomColumnAnchorEl(event.currentTarget);
    };
    var handleCustomColumnsClose = function () { return setCustomColumnAnchorEl(null); };
    var ExportOrderCSV = function (exportTab) { return __awaiter(_this, void 0, void 0, function () {
        var isRefundExport, dateFrom, dateTo, rows, _a, tabLabel, csv, blob, safeTab, fileName, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dismissExportNotice();
                    if (!dateRange.startDate || !dateRange.endDate) {
                        showExportNotice(t("stReports_noDateSelected"));
                        return [2 /*return*/];
                    }
                    isRefundExport = exportTab === "Refunded";
                    if (isRefundExport) {
                        if (!hasAnyVisibleRefundExportColumn(refundColumnVisibility)) {
                            showExportNotice(t("salesOrderDetails_exportCsv_selectColumn"));
                            return [2 /*return*/];
                        }
                    }
                    else if (!hasAnyVisibleOrderExportColumn(columnVisibility, selectFeatures)) {
                        showExportNotice(t("salesOrderDetails_exportCsv_selectColumn"));
                        return [2 /*return*/];
                    }
                    setIsCsvExporting(true);
                    dateFrom = formatDateForAPI(dateRange.startDate);
                    dateTo = formatDateForAPI(dateRange.endDate);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    if (!isRefundExport) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetchAllStReportRefundRowsForExport(dateFrom, dateTo)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, fetchAllStReportOrderRowsForExport(exportTab, dateFrom, dateTo)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    rows = _a;
                    if (rows.length === 0) {
                        tabLabel = t(SALES_ORDER_DETAILS_CSV_EXPORT_TAB_LABEL_KEYS[exportTab]);
                        showExportNotice(isRefundExport ? t("no_refund_to_show") : t("salesOrderDetails_exportCsv_noOrders", { tab: tabLabel }));
                        return [2 /*return*/];
                    }
                    csv = isRefundExport
                        ? buildRefundGridCsvFromSTOrderDetailsRows(rows, refundColumnVisibility, t, shopCurrency, currency)
                        : buildOrderGridCsvFromSTOrderDetailsRows(rows, columnVisibility, selectFeatures, t, shopCurrency, currency);
                    blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
                    safeTab = exportTab.replace(/[^a-zA-Z0-9_-]/g, "");
                    fileName = "ST_".concat(safeTab, "_").concat(dateFrom, "_").concat(dateTo, ".csv");
                    FileSaver.saveAs(blob, fileName);
                    setAnchorEl(null);
                    return [3 /*break*/, 8];
                case 6:
                    error_3 = _b.sent();
                    logClientRuntimeError("SalesOrderDetailsBL.ExportOrderCSV", error_3);
                    displaySnackbarErrMsg();
                    return [3 /*break*/, 8];
                case 7:
                    setIsCsvExporting(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return {
        t: t,
        handleClick: handleClick,
        handleClose: handleClose,
        open: open,
        id: id,
        anchorEl: anchorEl,
        ExportOrderCSV: ExportOrderCSV,
        isDesktop: isDesktop,
        isMobile: isMobile,
        isCsvExporting: isCsvExporting,
        dateRange: dateRange,
        setDateRange: setDateRange,
        columnVisibility: columnVisibility,
        setColumnVisibility: setColumnVisibilityWithPersist,
        refundColumnVisibility: refundColumnVisibility,
        setRefundColumnVisibility: setRefundColumnVisibilityWithPersist,
        customColumnAnchorEl: customColumnAnchorEl,
        handleCustomColumnsClick: handleCustomColumnsClick,
        handleCustomColumnsClose: handleCustomColumnsClose,
        isB2BShop: isB2BShop,
        resetColumnVisibility: function () {
            var defaults = createDefaultSalesOrderDetailsColumnVisibility(isB2BShop);
            setColumnVisibilityWithPersist(defaults);
        },
        resetRefundColumnVisibility: function () {
            var defaults = createDefaultSalesOrderDetailsRefundColumnVisibility();
            setRefundColumnVisibilityWithPersist(defaults);
        },
        exportNotice: exportNotice,
        dismissExportNotice: dismissExportNotice,
    };
}
